import React from 'react';
import { IconButton, IconButtonProps } from '@fiverr-private/button';
import { HomeIcon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';

const BreadcrumbsHomeIcon = ({ disabled, href }: Pick<IconButtonProps, 'disabled' | 'href'>) => (
  <IconButton
    disabled={disabled}
    intent="secondary"
    shape="circle"
    variant="ghost"
    size="3xs"
    aria-label={translate<string>('navigation.breadcrumb.breadcrumbsHomeIcon.home')}
    href={href}
  >
    <HomeIcon />
  </IconButton>
);

export default BreadcrumbsHomeIcon;
BreadcrumbsHomeIcon.id = 'BreadcrumbsHomeIcon';
BreadcrumbsHomeIcon.displayName = 'BreadcrumbsHomeIcon';
